import { render, staticRenderFns } from "./OvertimeDeleteModal.vue?vue&type=template&id=33904392&scoped=true"
import script from "./OvertimeDeleteModal.vue?vue&type=script&lang=js"
export * from "./OvertimeDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33904392",
  null
  
)

export default component.exports